import React from "react";
import styled from "styled-components";
export default function Results({ text, balls }) {
  return (
    <ResultsWrapper>
      <p>{text}</p>
      <div style={{ overflow: "scroll", scrollbarWidth: "none" }}>
        <BallsContainer width={balls.length}>
          {balls.map(({ number, won }, i) => (
            <Ball won={won} key={i}>
              <div />
              <span>{number}</span>
            </Ball>
          ))}
        </BallsContainer>
      </div>
    </ResultsWrapper>
  );
}

const ResultsWrapper = styled.div`
  font-size: 20px;
  margin-bottom: 32px;
  scrollbar-width: none;
  p {
    text-transform: none;
    margin-bottom: 16px;
    color: #32075b;
  }
`;

const BallsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  scrollbar-width: none;
  height: 56px;
  width: ${(p) => `${56 + 64 * (p.width - 1)}px`};
  overflow: scroll;
  transform: translate3d(0, 0, 0);
`;

export const Ball = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
  border: solid 0px #ffb000;
  font-size: 1em;
  line-height: 100%;
  border-radius: 45px;
  ${(p) =>
    p.won
      ? `background-color: #ffb000; color: #ff3920`
      : `background-color: #32075b; color: #7f3da5`}
  span {
    position: absolute;
    height: 16px;
    width: 30px;
    text-align: center;
    line-height: 16px;
    left: 50%;
    margin-left: -15px;
    top: 50%;
    margin-top: -8px;
  }
`;
